import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import ModuleListScene from './ModuleListScene';
import DistributorListService from '../../distributor/services/DistributorListService';
import { Roles } from '../../../core/util';
import ModuleCourseListService from '../services/ModuleCourseListService';

class ModuleListSceneContainer extends Component {
  static propTypes = {
    params: PropTypes.shape({
      moduleId: PropTypes.string,
    }).isRequired,
  };

  componentWillMount() {
    if (localStorage.role !== Roles.DISTRIBUTOR_CONTENT_ADMIN) {
      ModuleCourseListService.form.setValue('distributor', 'default');
    }
    DistributorListService.init();
    ModuleCourseListService.init();
  }

  handleFilterChange = (path, value) => {
    ModuleCourseListService.form.setValue(path, value);
    ModuleCourseListService.load();
  };

  render() {
    return (
      <ModuleListScene
        courses={toJS(ModuleCourseListService.courses).filter((c) => {
          if (localStorage.role === Roles.DISTRIBUTOR_CONTENT_ADMIN) {
            return !!c.distributor;
          }

          return ModuleCourseListService.form.getValue('distributor') &&
            ModuleCourseListService.form.getValue('distributor') !== 'default'
            ? !!c.distributor
            : !c.distributor;
        })}
        distributors={toJS(DistributorListService.distributors)}
        fetching={ModuleCourseListService.fetch.fetching}
        onFilterChange={this.handleFilterChange}
        filters={ModuleCourseListService.form.getValues()}
      />
    );
  }
}

export default observer(ModuleListSceneContainer);
